import Vue from 'vue'
import Router from 'vue-router'
import layout from '../layout/content.vue'
import store from '../store'
import { setDynamicMenu } from "@/utils/dynamicMenu.js";
import { message, Modal } from 'ant-design-vue';

Vue.use(Router)



let createRouter = () => new Router({
  routes: [
    {
      path: '/login',
      component: require('@/views/login/index').default
    },
    {
      path: '/',
      component: layout,
      // redirect: '/home',
      children: [
        // {
        //   path: '/home',
        //   component: require('@/views/home/index').default
        // }
      ]
    },
    {
      path: '/404',
      component: require('@/views/common/404').default,
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

var router = createRouter()



export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}



function isnext() {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title: '当前已开始培训操作，是否依然退出',
      content: '点击确认退出后当前培训数据将作废',
      cancelText: '点错了，不退出',
      okText: '依然退出当前培训',
      onOk: () => {
        resolve()
      },
      onCancel: () => {
        reject()
      },
    });
  })
}

const whiteRoutePath = ['/login', '/401', '/404']

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  if (to.path) {
    try {
      const dom = document.getElementById('bodyContnet')
      const body = document.body
      message.config({
        maxCount: 3,
        getContainer: () => (to.path == '/login' || from.path == '/login') ? body : dom //父组件元素ID
      })
      Vue.prototype.$message = message
    } catch (e) {
      console.log(e, '异常了')
    }

  }
  if (from.path === '/train/trainPlay' && from.query.ok !== 1) {
    await isnext()
  }
  // console.log('to:', to.fullPath, 'from:', from.fullPath)
  // console.log('-------------------------------------全局前置守卫-----------------------------------------')
  // 检查用户是否已登录 
  let isAuthenticated = localStorage.getItem("token")
  // console.log(isAuthenticated ? '有token' : '无无无token')
  // 如果用户未登录且要访问非登录页面或白名单页面，则跳转到登录页
  // if (!isAuthenticated) {
  if (!isAuthenticated && !whiteRoutePath.includes(to.path)) {
    next('/login')
    // index ? next() : next('/login')
  } else {
    //如果有token但是没有用户信息，那就走一边用户信息，并且
    if (isAuthenticated && JSON.stringify(store.state.user.userinfo) === '{}') {
      // console.log('/如果有token但是没有用s户信息，那就走一边用户信息,开始了')
      const key = 'updatable'
      message.loading({ content: '自动登录中···', key });
      setDynamicMenu().then(menu => {
        message.success({ content: '自动登录成功!', key, duration: 2 });
        // console.log(`/${menu[0].children[0].path}`)
        if (to.fullPath == '/' || from.fullPath == '/') {
          console.log(`/${menu[0].children[0].path}`, '走')
          // debugger
          next(`/${menu[0].children[0].path}`)
        } else {
          // debugger
          next()
        }
      }).catch((err) => {
        message.error({ content: '登录失效', key, duration: 2 });
        store.commit('setUserinfo', {})
        store.commit('setMenu', [])
        store.commit("setPermission", [])
        localStorage.removeItem('token')
        next('/login')
      })
    } else {
      console.log('正常放过去', to.path)
      next()
    }
  }
})


export default router